import { Box, Grid, Skeleton, Stack } from "@mui/material";

const OngoingDetailPurchaseSkeleton = () => {

    const windowWidth = window.innerWidth;
    return (
        <>
            <Grid className='overflow-y-auto mt-5' container gap={"1rem"} padding={"20px"}>
                <Skeleton animation="wave" width={"100%"} height="5rem" sx={{ transform: 'unset' ,paddingTop:"10px"}} />
                <Skeleton animation="wave" width={"100%"} height="3rem" sx={{ transform: 'unset' ,paddingTop:"10px"}} />
                <Skeleton animation="wave" width={"100%"} height="6rem" sx={{ transform: 'unset' ,paddingTop:"10px"}} />
                <Skeleton animation="wave" width={"100%"} height="10rem" sx={{ transform: 'unset',paddingTop:"10px" }} />
                <Skeleton animation="wave" width={"100%"} height="3rem" sx={{ transform: 'unset' ,paddingTop:"10px"}} />
                <Skeleton animation="wave" width={"100%"} height="3rem" sx={{ transform: 'unset' ,paddingTop:"10px"}} />
                <Skeleton animation="wave" width={"100%"} height="42px" sx={{ transform: 'unset' ,padding:"10px 0px"}} />
            </Grid>

        </>
    )
}

export default OngoingDetailPurchaseSkeleton;